import React, {useContext, useReducer} from 'react';
import {useFetch} from "react-admin-base";

const UserContext = React.createContext();
const UserRefreshContext = React.createContext();

export function useUser() {
    return useContext(UserContext);
}

export function useUserRefresher() {
    return useContext(UserRefreshContext);
}

export function UserProvider({ children }) {
    const [ v, update ] = useReducer(a => ++a, 0);
    const [ user ] = useFetch('/user/me?v=' + v);

    if (!user)
        return null;

    return <UserContext.Provider value={user}>
        <UserRefreshContext.Provider value={update}>
            { children }
        </UserRefreshContext.Provider>
    </UserContext.Provider>
}
